import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CreateSmartListButtonSpotlightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateSmartListButtonSpotlight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"}},{"kind":"Field","name":{"kind":"Name","value":"dateDismissed"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CreateSmartListButtonSpotlight","document":CreateSmartListButtonSpotlightDocument}} as const;
export type CreateSmartListButtonSpotlightQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateSmartListButtonSpotlightQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id'>
    & { campaigns: Array<(
      { __typename: 'Campaign' }
      & Pick<Types.Campaign, 'id' | 'currentStep' | 'dateDismissed' | 'name'>
    )> }
  )> }
);

/**
 * __useCreateSmartListButtonSpotlightQuery__
 *
 * To run a query within a React component, call `useCreateSmartListButtonSpotlightQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateSmartListButtonSpotlightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateSmartListButtonSpotlightQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateSmartListButtonSpotlightQuery(
  baseOptions?: TrelloQueryHookOptions<
    CreateSmartListButtonSpotlightQuery,
    CreateSmartListButtonSpotlightQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: CreateSmartListButtonSpotlightDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    CreateSmartListButtonSpotlightQuery,
    CreateSmartListButtonSpotlightQueryVariables
  >(CreateSmartListButtonSpotlightDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useCreateSmartListButtonSpotlightLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    CreateSmartListButtonSpotlightQuery,
    CreateSmartListButtonSpotlightQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CreateSmartListButtonSpotlightQuery,
    CreateSmartListButtonSpotlightQueryVariables
  >(CreateSmartListButtonSpotlightDocument, options);
}
export function useCreateSmartListButtonSpotlightSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        CreateSmartListButtonSpotlightQuery,
        CreateSmartListButtonSpotlightQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CreateSmartListButtonSpotlightQuery,
    CreateSmartListButtonSpotlightQueryVariables
  >(CreateSmartListButtonSpotlightDocument, options);
}
export type CreateSmartListButtonSpotlightQueryHookResult = ReturnType<
  typeof useCreateSmartListButtonSpotlightQuery
>;
export type CreateSmartListButtonSpotlightLazyQueryHookResult = ReturnType<
  typeof useCreateSmartListButtonSpotlightLazyQuery
>;
export type CreateSmartListButtonSpotlightSuspenseQueryHookResult = ReturnType<
  typeof useCreateSmartListButtonSpotlightSuspenseQuery
>;
export type CreateSmartListButtonSpotlightQueryResult = Apollo.QueryResult<
  CreateSmartListButtonSpotlightQuery,
  CreateSmartListButtonSpotlightQueryVariables
>;
